import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './companypolicy.json';

const Companypolicy = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Workplace policies, HR vocabulary, and professional English. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Company Policy"
            image="/Images/companypolicy1.webp"
            seoTitle="Free English Lesson Plans: Company Policy"
            seoDescription="Workplace policies, HR vocabulary, and professional English. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Companypolicy;


